<template>
  <div class="box text-gray">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "MainSubtitle",
  props: {
    text: { type: String }
  }
}
</script>

<style scoped>
.box {
  text-align: center;
  font-size: var(--ecs-font-md);
  margin: 1vh 15vh 2vh 15vh;

  /*text-align: center;*/
  /*margin: 2vh auto;*/
  /*font-size: var(--ecs-font-md);*/
}
</style>
